import { Fragment, createElement, type ReactNode } from 'react'

type Params = Record<string, string | number>

const PLACEHOLDER = /\{(\w+)\}/g
// Placeholders plus the only tags translations may contain: <b>…</b> and <br />.
const RICH_TOKEN = /(<b>[\s\S]*?<\/b>|<br \/>|\{\w+\})/

// Fills `{name}` placeholders in a translation. A placeholder without a param is left as it is, so
// it shows up in the UI instead of silently disappearing.
export function format(text: string, params: Params): string
export function format(text: string | undefined, params: Params): string | undefined
export function format(text: string | undefined, params: Params): string | undefined {
  return text?.replace(PLACEHOLDER, (match, name: string) =>
    name in params ? String(params[name]) : match
  )
}

// Like format(), but also renders <b>…</b> and <br />, and params can be elements.
export const formatRich = (text: string, params: Record<string, ReactNode> = {}): ReactNode =>
  text.split(RICH_TOKEN).map((part, index) => {
    if (part === '<br />') return createElement('br', { key: index })
    if (part.startsWith('<b>'))
      return createElement('b', { key: index }, formatRich(part.slice(3, -4), params))

    const name = /^\{(\w+)\}$/.exec(part)?.[1]
    if (name && name in params) return createElement(Fragment, { key: index }, params[name])

    return part
  })
